import { useAuth } from "react-oidc-context";
import { useAffiliate } from "../lib/hooks/useAffiliate";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAffiliates } from "../lib/api/resources/affiliates";
import { Select } from "antd";

export const AffiliateSwitcher = () => {
  const { currentAffiliate, setCurrentAffiliate } = useAffiliate();
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const affiliatesQuery = useQuery({
    queryKey: ["affiliates"],
    queryFn: fetchAffiliates,
  });

  if (
    !user ||
    !Array.isArray(user.profile?.organization) ||
    user.profile.organization.length === 1
  )
    return null;

  const sortedAffiliates = (user.profile.organization as string[])
    .map((id) => ({
      id,
      name:
        affiliatesQuery.data?.member?.find((org) => org.id === id)?.name ?? id,
    }))
    .sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
    );

  return (
    <Select
      value={currentAffiliate}
      onChange={(value) => {
        setCurrentAffiliate(value);
        queryClient.resetQueries({
          predicate: (query) => query.queryKey[0] !== "affiliates",
        });
      }}
      style={{ width: "100%" }}
      placeholder="Selecteer een affiliate"
      loading={affiliatesQuery.isLoading}
      disabled={affiliatesQuery.isLoading}
      showSearch={{
        optionFilterProp: "label",
      }}
      options={sortedAffiliates.map(({ id, name }) => ({
        value: id,
        label: name,
      }))}
    />
  );
};
